import React from "react";

import AppLayout from "./src/layouts/app";
import DefaultLayout from "./src/layouts/default";
import LoginLayout from "./src/layouts/login";

export { default as wrapRootElement } from "./src/state/reduxWrapper";

const Container = ({ children }) => <div>{ children }</div>

export const wrapPageElement = ({ element, props }) => {
    if (props.path.match(/(^\/account\/|^\/new\/)/)) return <AppLayout { ...props }>{ element }</AppLayout>;
    if (props.path.match(/(^\/contact\/|^\/privacy\/|^\/sayonara\/|^\/terms\/)/)) return <DefaultLayout { ...props }>{ element }</DefaultLayout>;
    if (props.path.match(/^\/authorize\//)) return <LoginLayout { ...props }>{ element }</LoginLayout>;
    return <Container { ...props }>{ element }</Container>;
};
